import { memo, useState, useEffect } from 'react'
import { Tooltip } from 'ui_kit_qmd'
import { isActiveEllipsisCheck } from '../../../../utils/common'
import './InfoCardRow.scss'

// @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
export const InfoCardRow = memo(({ keyValue, value, isTheLast }) => {
  const [isShowValuePopUp, setIsShowValuePopUp] = useState(false)

  useEffect(() => {
    const timer = setInterval(() => {
      isActiveEllipsisCheck(`${keyValue}-${value}`, setIsShowValuePopUp)
    }, 1000)
    return () => clearInterval(timer)
  }, [keyValue, value])

  return (
    <div className={`info-card-row-wrapper${isTheLast ? 'info-card-row-wrapper--last-item' : ''}`}>
      {keyValue ?
        <div className='info-card-text info-card-row-key'>{keyValue}:</div>
      : null}
      <Tooltip content={value} disabled={!isShowValuePopUp}>
        <div id={`${keyValue}-${value}`} className='info-card-text info-card-row-value drop-safari-tooltip'>
          {value}
        </div>
      </Tooltip>
    </div>
  )
})
